export const styles = {
  icon: {
    fontSize: 20,
    color: 'gray',
  },
};
